import { InputGroup, Input, InputLeftElement } from "@chakra-ui/react";
import { Search } from "@airhelp/icons";
import type { FilterProps } from "./Filter.d";

const Filter = ({ filter, setFilter, placeholder }: FilterProps) => (
  <InputGroup mt={{ base: 4, md: 0 }} w={{ base: "full", lg: 60 }}>
    <Input
      border="1px"
      borderColor="greyscale.400"
      color="primary.900"
      fontSize="md"
      type="text"
      value={filter || ""}
      onChange={({ target: { value } }) => setFilter(value)}
      placeholder={placeholder}
    />
    <InputLeftElement>
      <Search w={5} h="auto" mt={1} color="greyscale.500" />
    </InputLeftElement>
  </InputGroup>
);

export default Filter;
